import Img2016 from "../../assets/images/about/2016-img.webp" 
import Img2017 from "../../assets/images/about/2017-img.webp" 
import Img2018 from "../../assets/images/about/2018-img.webp" 
import Img2019 from "../../assets/images/about/2019-img.webp" 
import Img2020 from "../../assets/images/about/2020-img.webp" 
import Img2021 from "../../assets/images/about/2021-img.webp" 
import Img2022 from "../../assets/images/about/2022-img.webp" 
import Img2023 from "../../assets/images/about/2023-img.webp" 
import Img2024 from "../../assets/images/about/2024-img.webp" 

import ValueIcon from "../../assets/images/about/transparancy.png"
import ValueIconWhite from "../../assets/images/about/transparancy-white.png"

import ValueIcon2 from "../../assets/images/about/integrity.png"
import ValueIcon2White from "../../assets/images/about/integrity-white.png"

import ValueIcon3 from "../../assets/images/about/commitment.png"
import ValueIcon3White from "../../assets/images/about/commitment-white.png"

import ValueIcon4 from "../../assets/images/about/excellence.png"
import ValueIcon4White from "../../assets/images/about/excellence-white.png"

import ValueIcon5 from "../../assets/images/about/innovation.png"
import ValueIcon5White from "../../assets/images/about/innovation-white.png"

import ValueIcon6 from "../../assets/images/about/empowerment.png"
import ValueIcon6White from "../../assets/images/about/empowerment-white.png"


const AboutPageData = {
    
    "TimelineCont" : [
        {
            "imgCont" : `${Img2016}`,
            "date": '2016',
            "Description" : `Incorporated and started with 5-member website development team</p>`,            
        },
        {
            "imgCont" : `${Img2017}`,
            "date": '2017',
            "Description" : `Investica - A Mutual Fund Platform<br><br>
            Neuron - An integrated single window operations platform for back office, and KYC<br/><br>
            e-Billing system deployments<br><br>
            2017 - Project monitoring Portal & App launch</p>`,            
        },
        {
            "imgCont" : `${Img2018}`,
            "date": '2018',
            "Description" : `Jiffy Launch - Stock Trading Platform<br><br>Women Entrepreneurship Platform (NITI Aayog)<br><br>Accounting System launch with UIDAI`,            
        },
        {
            "imgCont" : `${Img2019}`,
            "date": '2019',
            "Description" : `Choice Connect - B2B Fintech Platform for Choice<br><br>Infrastructure ERP launch `,            
        },
        {
            "imgCont" : `${Img2020}`,
            "date": '2020',
            "Description" : "Back office platforms for Insurance & Retail Loan <br/><br/>Organizational Pivot to counter COVID impact",            
        },
        {
            "imgCont" : `${Img2021}`,
            "date": '2021',
            "Description" : "Add two new branch at Pune & Bhopal locations<br/><br/>Robust Cyber Security & DevOps implementations",            
        },
        {
            "imgCont" : `${Img2022}`,
            "date": '2022',
            "Description" : `Choice FinX launch (formally Jiffy) - A finance SuperApp (Stocks, IPO, MF, Insurance)<br/><br/> Telelyzer – a comprehensive platform that empowers lenders with tools for loan origination, underwriting, and loan management.`,            
        },
        {
            "imgCont" : `${Img2023}`,
            "date": '2023',
            "Description" : `Prime – an enterprise solution to effective manage procurement cycle, expense management, invoicing, travel desk, etc.<br><br> Drive Assure – Insurance digitization solution provides end-to-end issuance for Motor, Health, Travel, and Hospicash Insurance.`,            
        },
        {
            "imgCont" : `${Img2024}`,
            "date": '2024',
            "Description" : `Chatbots launch with sentimental analysis<br/><br/>Greetly.ai - Customer interaction platform<br/><br/>Choice Touch launch`,            
        },
        
        

    ],

    
    "CoreValues" : [
        {
            "id" : '1',
            "heading" : "Transparency",
            "Img1": `${ValueIcon}`,
            "Img2": `${ValueIconWhite}`
        },
        {
            "id" : '2',
            "heading" : "Integrity",
            "Img1": `${ValueIcon2}`,
            "Img2": `${ValueIcon2White}`
            
        },
        {
            "id" : '3',
            "heading" : "Commitment",
            "Img1": `${ValueIcon3}`,
            "Img2": `${ValueIcon3White}`
        },
        {
            "id" : '4',
            "heading" : "Excellence",
            "Img1": `${ValueIcon4}`,
            "Img2": `${ValueIcon4White}`
        },
        {
            "id" : '5',
            "heading" : "Innovation",
            "Img1": `${ValueIcon5}`,
            "Img2": `${ValueIcon5White}`
        },
        {
            "id" : '6',
            "heading" : "Empowerment",
            "Img1": `${ValueIcon6}`,
            "Img2": `${ValueIcon6White}`
        },

    ],

    "FooterCtaSection":[
        {
            "CtaHeading": "Join Us on this Journey",
            "CtaDescriptiom":"Choice TechLab invites you to embark on an innovation journey. Let's collaborate to make your product vision a reality.",
            "CtaBtnText": `Let's Build Together`,
            "CtaBtnLink": '/get-a-quote',
        },
    ],
    
} 

export default AboutPageData